import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-screen flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50 to-white"></div>
        
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Wall Setup &amp; Home Installations
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-10">
            Expert insights for modern home entertainment setups
          </p>
          <Link 
            to="/blog"
            className="inline-flex items-center px-8 py-4 bg-gray-900 text-white text-lg font-medium rounded-lg hover:bg-gray-800 cursor-pointer whitespace-nowrap"
          >
            Read Our Blog
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>&copy; 2024 Wall Setup &amp; Home Installations. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 hover:text-gray-900 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
